import React, {useEffect, useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import * as dayjs from 'dayjs'
import * as utc from 'dayjs/plugin/utc'
import * as timezone from 'dayjs/plugin/timezone'
import * as relativeTime from 'dayjs/plugin/relativeTime'
import {useSolv} from "./components/SolvProvider";
import {useIntlEx} from "./components/IntlUtils.js"
import {AsyncPaginate} from 'react-select-async-paginate'
import {InfoBlock} from "./components/ValidationUtils.js"
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {mkExtraParams} from "./components/TableComps";
import {Alert, FormGroup, useAlert} from "./components/FormComps";
import getLogger from "./components/Logging.js"
import './App.css'
import {isNonEmptyArray} from "./components/Utils";

const log = getLogger("ResellerMoveDialog")

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

export default function ResellerMoveDialog(props)  {

  const {api, session: {user}, setBusy, setFatal} = useSolv()
  const {intl} = useIntlEx()

  const [eligibleParent, setEligibleParent] = useState(null)

  const [touched, setTouched] = useState(true)
  const [alert, setAlert] = useAlert(null)

  useEffect(() => {
    // log.debug(">>>Z: useEffect: tenant=", props.tenant)
  }, [props]);

  function loadEligibleParents(search, loadedOptions, additional) {
    return api.listeEligibleParents({tenantId: props.tenant.tenantId, extraParams: mkExtraParams({filterParams: {tenantName: search?.trim()}, sortParams: {tenantName: "ASC"}}), cursor: additional?.cursor})
      .then(({data, nextCursor}) => {
        // log.debug(">>>Z: listParentResellerCandidates: data=", data)
        let opt = data.map(c => {
            return {
              value: c.tenantId,
              label: (isNonEmptyArray(c.pathSpec) ? (
                c.pathSpec.flatMap((item, index) => [
                  <span key={index}>{item}</span>,
                  index < c.pathSpec.length - 1 && (
                    <span key={`sep-${index}`} className="text-muted"> of </span>
                  )
                ]).filter(Boolean)
              ) : c.tenantName),
            };
        });
        let res = {
          options: opt,
        }
        if (nextCursor) {
          res = {
            ...res,
            hasMore: true,
            additional: {
              cursor: nextCursor
            }
          }
        }
        // log.debug(">>>Z: listParentResellerCandidates: res=", res)
        return res
      });
  }

  function validate() {
    return true
  }
    
  async function handleMoveClick() {

    setAlert(null)

    if (validate()) {

      setBusy(intl.msg("working"))
      try {

        const payload = {
          newParentTenantId: eligibleParent.value,
        }

        const {data} = await api.moveReseller(props.tenant.tenantId, payload)

        window.location.reload()
      }
      catch (err) {
        handleError(err)
      }
      finally {
        setBusy(null)
      }

    }
    else {
      // log.debug("Validation error")
      setAlert({type: "error", text: intl.msg("error_validation")})
      setTouched(true)
    }

  }
  
  function handleError(error) {
    if (error && error.code) {
      // log.debug("handleError: error=", error.code)
      switch (error.code) {
        case "DUPLICATE_KEY":
        case "DUPLICATE_RESELLER":
          setAlert({type: "error", text: intl.msg("reseller_move_error_sub_reseller_already_exits")})
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed")})
      }
    }
    else {
          setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }
      
  function handleEligibleParentChange(value) {
    // log.debug("handleParentResellerChange: value=", value)
    setEligibleParent(value)
    setTouched(true)
  }
    
  function canEdit() {
    return true
  }

  function handleOpenDialog() {
    setAlert(null)
    setBusy(null)
  }

  function handleCloseDialog() {
    closeDialog("dlg_reseller_move")
  }

  return (

    // props.tenant ? (
      <ModalDialog
        dialogId="dlg_reseller_move"
        size="lg"
        keyboard={"true"}
        backdrop={props.backdrop || "static"}
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}>

        <ModalDialog.Header title={intl.msg("reseller_move_title")} description={intl.msg("reseller_move_description")} alert={alert}/>

        <ModalDialog.Body>

          <Alert className="pb-3" alert={{warning: intl.msg("reseller_move_alert", {tenantName: props?.tenant?.tenantName})}}/>

          <FormGroup>
            <FormGroup.Label text={intl.msg("reseller_move_parent_reseller")} description={intl.msg("reseller_move_parent_reseller_description")} htmlFor="inp_parentReseller"/>
            <FormGroup.Controls>
              <AsyncPaginate
                id="inp_parentReseller"
                className="react-select"
                classNamePrefix="react-select"
                cacheOptions
                isClearable
                value={eligibleParent}
                debounceTimeout={800}
                defaultOptions={true}
                hideSelectedOptions={true}
                loadOptions={loadEligibleParents}
                onChange={handleEligibleParentChange}
                isDisabled={!canEdit()}
              />
              <InfoBlock>
              </InfoBlock>
            </FormGroup.Controls>
          </FormGroup>

        </ModalDialog.Body>

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            <button className="btn btn-secondary" onClick={handleCloseDialog}>{intl.msg("cancel")}</button>
            {
              eligibleParent &&
                <button type="button" className="btn btn-primary" onClick={handleMoveClick}>{intl.msg("move")}</button>
            }
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>
      </ModalDialog>
    // ) : (
    //   <></>
    // )
  )
}